import React, { useEffect, useState } from 'react';

import './imageFooted.scss';

interface ImageFootedProps {
    src?: string;
    children?: React.ReactNode;
    explanation: string;
}

const ImageFooted: React.FC<ImageFootedProps> = ({ src, explanation, children }) => {
    const imageRef = React.createRef<HTMLDivElement>();
    const [pWidth, setPwidth] = useState('100%');

    useEffect(() => {
        setTimeout(() => {

            const width = imageRef.current.getBoundingClientRect().width;
            setPwidth(`${width}px`);
        }, 20)
    }, [])

    return (
        <div className="__ImageFooted" ref={imageRef}>
            <div className="_reference" style={{ maxWidth: pWidth }}>
                {children}
            </div>
            <p className="explain" style={{ width: pWidth }}>
                {explanation.split(' ').map((s, i) => s === '\n' ? <br key={i} /> : (s.includes('\n') ? <span key={i}><br />{s.replace('\n', '') + ' '}</span> : <span key={i}>{s + ' '}</span>))}
            </p>
        </div>
    )
}

export default ImageFooted;